module.exports = __webpack_public_path__ + "img/lx_05.85563847.jpg";